// extracted by mini-css-extract-plugin
module.exports = {"b6a0zqe":"b6a0zqe","aa1v15b":"aa1v15b","s1xbt4ai":"s1xbt4ai"};